/**
 * Carrossel opcional para sections/multicolumn-icon.liquid
 * (baseado em featured-collection.js + product-slider.js; mantém Swiper em mobile e desktop)
 */
if (!customElements.get('multicolumn-icon-slider')) {
  customElements.define(
    'multicolumn-icon-slider',
    class MulticolumnIconSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseFloat(this.dataset.items) || 4;
        this.laptopItems = parseFloat(this.dataset.laptopItems) || this.items;
        this.tabletItems = parseFloat(this.dataset.tabletItems) || 2;
        this.mobileItems = parseFloat(this.dataset.mobileItems) || 1.5;
        this.paginationType = this.dataset.paginationType || 'progressbar';

        this.sliderInstance = false;

        if (!this.enableSlider) return;
        if (!this.sliderWrapper || !this.section) return;

        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(String(columnGap).replace('rem', '')) * 10 || 0;

        const paginationEl = this.section.querySelector(this.selectors.pagination);
        const nextEl = this.section.querySelector(this.selectors.nextEl);
        const prevEl = this.section.querySelector(this.selectors.prevEl);

        this.sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween,
          navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
          pagination: paginationEl
            ? {
                el: paginationEl,
                type: this.paginationType,
                clickable: true,
              }
            : undefined,
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [
          FoxTheme.Swiper.Mousewheel,
        ]);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            if (slide && this.sliderInstance?.slider) {
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            }
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== this.sectionId) return;
            const target = e.target;
            const index = Number(target.dataset?.index);
            if (Number.isNaN(index) || !this.sliderInstance?.slider) return;
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }
  );
}
